function setCookie(cname, cvalue, exdays) {
	var d = new Date();
	d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
	var expires = "expires=" + d.toUTCString();
	document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
	var name = cname + "=";
	var ca = document.cookie.split(';');
	for (var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) == ' ') {
			c = c.substring(1);
		}
		if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length);
		}
	}
	return "";
}

$(document).ready(function () {

	// Scroll to top
	$('.footer-to-top').on('click', function (event) {
		event.preventDefault();
		$('html, body').stop().animate({
			scrollTop: 0,
		}, 1000);
	});

	// Scroll to target
	$('.scroll-to').on('click', function (event) {
		event.preventDefault();
		var target = $(this).attr('href');
		$('html, body').stop().animate({
			scrollTop: $(target).offset().top
		}, 1000);
	});

	// Product Filter Button
	$(".product-filter").click(function (event) {
		event.preventDefault();
		$(".filter-container").slideToggle("slow");
		$(".filter-rotate").toggleClass("icon--rotate-active");
	});

	$('#product-finder').click(function () {
		$('.product-selector').toggleClass('product-selector--active');
		$('body').toggleClass('no-scroll');
	});

	$('#product-finder-close').click(function () {
		$('.product-selector').toggleClass('product-selector--active');
		$('body').toggleClass('no-scroll');
	});

	$('.go-to-select').on('change', function () {
		var url = $(this).val(); // get selected value
		if (url) { // require a URL
			window.location = url; // redirect
		}
		return false;
	});

	// Language Dropdown
	$("select#language").on("change", function (event) {
		event.preventDefault();

		// Get the URL pathname
		var $pathname = window.location.pathname;
		// Split on slash
		var $split = $pathname.split('/');
		// Split Language-Region
		var $languageRegion = String($split[1]).split('-');
		// Current Language does not equal the one selected
		if ($languageRegion[0] != $(this).val()) {
			// Change the Language
			$languageRegion[0] = $(this).val();
		}

		// Update the Language-Region in the main URL split
		$split[1] = $languageRegion.join('-');

		// Finally build the URL back up & redirect
		window.location.href = $split.join('/');
	});

	$('#vmap').vectorMap({
		map: 'world_en',
		backgroundColor: '#f1f1ef',
		color: '#ffffff',
		hoverColor: '#d4d3d3',
		hoverOpacity: 0,
		selectedColor: '#e61e26',
		enableZoom: false,
		showTooltip: true,
		borderColor: '#c6c6c6',
		borderOpacity: 0.7,
		borderWidth: 1,
		onRegionClick: function (element, code, region) {
			window.location.replace("/?region-code=" + code);
		}
	});

	// $( ".vacancy" ).click(function() {
	//     $( ".vacancy__drop-down", this ).slideToggle();
	//     });
	// });
	$('.vacancy').on('click', function () {
		$(this).find('.vacancy__drop-down').slideToggle(200);
	})

	//Smooth Scroll
	$('a[href^="#"]').on('click', function (event) {
		var target = $(this.getAttribute('href'));
		if (target.length) {
			event.preventDefault();
			$('html, body').stop().animate({
				scrollTop: target.offset().top
			}, 1000);
		}
	});

	toggleFields();

	$(".chooseoptions").selectBoxIt();

	var selectBox = $(".options").selectBoxIt();


	//this will call our toggleFields function every time the selection value of our underAge field changes
	$("#form2_market").change(function () {
		toggleFields();
	});

	//this toggles the visibility of our parent permission fields depending on the current selected value of the underAge field
	function toggleFields() {

		$("[class^=opt-]").hide();
		$(selectBox).selectBoxIt('selectOption', 'Select a product');

		switch ($("#form2_market").val()) {
			case "Food Service":
				$(".opt-foodservice").show();
				break;
			case "Building Care":
				$(".opt-buildingcare").show();
				break;
			case "Industry":
				$(".opt-industry").show();
				break;
			case "Health Care":
				$(".opt-healthcare").show();
				break;
			case "Automotive":
				$(".opt-automotive").show();
				break;
			case "Aerospace":
				$(".opt-aerospace").show();
		}

	}

	$(".slider").each(function (k, v) {
		var $this = $(this);

		$this.slider({
			animate: true,
			range: "min",
			value: ($this.data("default")) ? $this.data("default") : 1,
			min: 1,
			max: ($this.data("max")) ? $this.data("max") : 6,
			step: 1,

			//this gets a live reading of the value and prints it on the page
			slide: function (event, ui) {
				// $( "#slider-result" ).html( ui.value );
			},

			//this updates the hidden form field so we can submit the data using a form
			change: function (event, ui) {

				// Only trigger the event if there's an originalEvent
				// Issue with multiple triggers when the applied filter 'Reset' link is clicked
				if (event.originalEvent) {
					$(this).parents(".option").find(":input").val(ui.value).trigger("change");
				} else {
					$(this).parents(".option").find(":input").val(ui.value);
				}
				// $('#hidden').attr('value', ui.value);

			}

		});

	});

	// Show Filters if manually set
	if ($(".product__filters-applied li").length > 1) {
		showHideFilters();
	}

	// Filter inputs change --- Changes applied filter text on product listing pages
	$(".col-product__filter :input").on("change", function (e) {

		e.preventDefault();

		// Deal with inputs that have the filter-name data attribute e.g. checkboxes
		if ($(this).data("filter-name")) {

			// Deal with checkboxes
			if ($(this).attr('type') == 'checkbox') {

				// Add applied filter if checked
				if ($(this).is(':checked')) {

					$(".product__filters-applied .reset").parent().before("<li><a href='#' class='filter-" + $(this).attr("name") + "' data-input-name='" + $(this).attr("name") + "'>" + $(this).data("filter-name") + "</a></li>");

					// Remove applied filter if un-checked
				} else {

					$(".product__filters-applied .filter-" + $(this).attr("name")).parent().remove();

				}
			}

			// Deal with radio
			if ($(this).attr('type') == 'radio') {

				$(".product__filters-applied .filter-" + $(this).attr("name")).parent().remove();

				// Add applied filter if checked
				if ($(this).is(':checked')) {

					$(".product__filters-applied .reset").parent().before("<li><a href='#' class='filter-" + $(this).attr("name") + "' data-input-name='" + $(this).attr("name") + "'>" + $(this).data("filter-name") + "</a></li>");

				}
			}

			// Deal with hidden inputs (sliders)
			else if ($(this).attr('type') == 'hidden') {

				$sliderName = "Good";

				// Slider has 3 points so values are different
				if ($(this).data('count') == 3) {
					if ($(this).val() == 2) {
						$sliderName = "Better";
					} else if ($(this).val() == 3) {
						$sliderName = "Best";
					}
				} else if ($(this).data('count') == 6) {
					$sliderName = $(this).val();
				} else {
					if ($(this).val() == 3) {
						$sliderName = "Better";
					} else if ($(this).val() == 4) {
						$sliderName = "Best";
					}
				}

				// Remove all applied filter options
				$(".product__filters-applied .filter-" + $(this).attr("name")).parent().remove();

				// Slider is active (not off)
				if ($(this).val() > 1) {
					$(".product__filters-applied .reset").parent().before("<li><a href='#' class='filter-" + $(this).attr("name") + "' data-input-name='" + $(this).attr("name") + "'>" + $(this).data("filter-name") + " - " + $sliderName + "</a></li>");
				}

			}

			// Deal with select inputs
		} else if (this.tagName == "SELECT") {

			// Remove all applied filter options
			$(".product__filters-applied .filter-" + $(this).attr("name")).parent().remove();

			// Check is filter text exists for industrial rating select box
			var filterText = $(this).is("[filter]");

			// Add applied filter if value is not empty and filter text is true
			if ($(this).val() && filterText == true) {

				if ($(this).hasClass('show-selected-text')) {
					$(".product__filters-applied .reset").parent().before("<li><a href='#' class='filter-" + $(this).attr("name") + "' data-input-name='" + $(this).attr("name") + "'>" + $(this).attr("filter") + $(this).children(':selected').text() + "</a></li>");
				} else {
					$(".product__filters-applied .reset").parent().before("<li><a href='#' class='filter-" + $(this).attr("name") + "' data-input-name='" + $(this).attr("name") + "'>" + $(this).attr("filter") + $(this).val() + "</a></li>");
				}

			}

			// Add applied filter if value is not empty
			else {
				$(".product__filters-applied .reset").parent().before("<li><a href='#' class='filter-" + $(this).attr("name") + "' data-input-name='" + $(this).attr("name") + "'>" + $(this).val() + "</a></li>");
			}

		}

		// Show/hide filters depending if there are any selected options
		showHideFilters();

		// Refresh Products
		// filterFormAjax($(this).parents("form"));

	});

	// Applied Filter links
	$(document).on("click", ".product__filters-applied a", function (e) {

		e.preventDefault();

		$.fn.getType = function () { return this[0].tagName == "INPUT" ? this[0].type.toLowerCase() : this[0].tagName.toLowerCase(); };

		// Reset link
		if ($(this).hasClass("reset")) {

			window.location.href = location.protocol + '//' + location.host + location.pathname;

			// Remove all applied filters
			$(".product__filters-applied li").not($(this).parent()).remove();

			// Reset the form
			var $form = $(this).parents(".product__filters-applied").next().find(".filters__form");
			$form.find(".slider").slider("value", 1);
			$form.find("input:radio, input:checkbox").removeAttr("checked").removeAttr("selected");
			$form.find("select").find('option').removeAttr('selected');
			$form.trigger("reset");

			// Refresh Products
			// filterFormAjax($form);

			// Remove individual filter
		} else {

			// Remove the applied filter
			$(this).parent().remove();

			// Get input from data attribute
			var $input = $(":input[name='" + $(this).data("input-name") + "']");

			if ($input.attr("type") == "radio") {

				$input.prop("checked", false).trigger("change");

			}

			// Untick the checkbox
			if ($input.attr("type") == "checkbox") {

				$input.prop("checked", false).trigger("change");

				// Set slider to 1 (off)
				// Need to manually refresh as the change isn't triggered
			} else if ($input.attr("type") == "hidden") {

				$input.parent().find(".slider").slider("value", 1);
				// filterFormAjax($(this).parents(".product__filters-applied").next().find(".filters__form"));

				// Set select to empty
			} else if ($input.getType() == "select") {

				$input.val("").trigger("change");

			}

		}

		// Show/hide filters depending if there are any selected options
		showHideFilters();

	});


	// function filterFormAjax($form) {

	//     $.ajax({
	//         method: "GET",
	//         url: $form.attr("action"),
	//         data: $form.serialize()
	//     })
	//         .done(function (html) {
	//             // Update Products HTML
	//             $products = $("<div />").append(html).find(".col-product");

	//             // Empty if no Products returned
	//             if ($products.length) {
	//                 $(".col-product").html($products.html());
	//             } else {
	//                 $(".col-product").html('');
	//             }
	//         });

	// }

	function showHideFilters() {

		// Hide filters if only the reset link is present
		if ($(".product__filters-applied li").length == 1) {
			$(".product__filters-applied").hide();

			// Otherwise show the filters
		} else {
			$(".product__filters-applied").show();
		}
	}




	// Adding superscript <sup> tags around all trademark and registered trademark symbols
	// Basically looks for all (™®©) and adds a <sup> tag around them
	// Found the solution here - http://bit.ly/1VWnqpl

	// $('body :not(script,sup)').contents().filter(function() {
	//     return this.nodeType === 3;
	// }).replaceWith(function() {
	//     return this.nodeValue.replace(/[™®©]/g, '<sup>$&</sup>');
	// });

	$(".header").headroom({
		offset: 55,
	});

	$(".breadcrumbs__sticky").headroom({
		"offset": 55,
		// "tolerance": 5,
		"classes": {
			"initial": "headroom-quick",
			"pinned": "headroom--pinheader",
			"unpinned": "headroom--unpinheader"
		}
	});


	$('.table').stacktable();


	var settings = {
		trigger: 'click',
		title: 'WebUI Popover',
		content: '<p>This is webui popover demo.</p><p>just enjoy it and have fun !</p>',
		width: 450,
		multi: false,
		closeable: true,
		style: '',
		delay: 300,
		padding: true
	};

	$('a.pop-up').webuiPopover('destroy').webuiPopover(settings);




	//     var $product_selectors = $("#product-selectors").hide();
	//     var $regions = $("#regions").hide();
	var $test = $("#test").hide();
	//var $appliedFilters = $(".product__filters-applied").hide();

	//     $("#product-finder").on("click", function(e){
	//         $(this).toggleClass("expanded");
	//         $product_selectors.slideToggle();
	//         $('.dropdown-menu').removeClass('is-visible');
	//         $("#regions").hide();
	//         $("#test").hide();
	//         $("html, body").animate({ scrollTop: 0 }, "fast");
	//     });

	$("#product-finder-footer").on("click", function (e) {
		$('#product-finder').toggleClass("expanded");
		$product_selectors.slideToggle();
		$("html, body").animate({ scrollTop: 0 }, "fast");
	});

	$("#country").on("click", function (e) {
		$(this).toggleClass("expanded");
		$("#regions").addClass('active');
		console.log('1');
		$('.dropdown-menu').removeClass('is-visible');
		$("html, body").animate({ scrollTop: 0 }, "fast");
	});

	$(".close-overlay").on("click", function (e) {
		$("#regions").removeClass('active');
		$("#regionsEU").removeClass('active');
	});

	$('.region-options li a').on('click', function () {
		var region = $(this).data('region');
		setCookie("region", region, 365);
		$('#regions').removeClass('active');
		$("#regionsEU").removeClass('active');
		return true;
	});

	$("#testing").on("click", function (e) {
		$(this).toggleClass("expanded");
		$test.slideToggle();
		console.log('2');
		$('.dropdown-menu').removeClass('is-visible');
		//         $("#product-selectors").hide();
		// $("#regions").hide();
		$("html, body").animate({ scrollTop: 0 }, "fast");
	});


	$('.hero').flexslider({
		animation: 'slide',
		slideshow: true,
		slideshowSpeed: 7000,
		animationSpeed: 500,
		useCSS: false,
		smoothHeight: true,
		pauseOnHover: true,
		mousewheel: false,
		multipleKeyboard: true,
		directionNav: true,
		controlNav: true
	});

	$('.menu-slideshow__images').flexslider({
		animation: "fade",
		multipleKeyboard: false,
		slideshow: false,
		controlNav: false,
		directionNav: false,
		useCSS: false,
	});

	$('.faq-slideshow__images').flexslider({
		animation: "fade",
		multipleKeyboard: false,
		slideshow: false,
		controlNav: false,
		directionNav: false,
		useCSS: false,
	});

	$('.caption__container').flexslider({
		animation: "fade",
		slideshow: false,
		smoothHeight: true,
		animationSpeed: 500,
		directionNav: false,
		controlsContainer: ".container",
		controlNav: true,
		sync: ".menu-slideshow__images",
		manualControls: ".slideshow-nav li",
		start: function () {
			$('.tab-container').resize();
		},
	});



	$('.faqs').flexslider({
		animation: "fade",
		smoothHeight: true,
		slideshow: false,
		animationSpeed: 500,
		directionNav: false,
	});


	$('.product-slider').flexslider({
		animation: "slide",
		controlNav: false,
		slideshow: false,
		directionNav: true,
		start: function (slider) {
			$('.product-slider').removeClass('loading');
		}
	});

	$('.blockquote').flexslider({
		animation: "slide",
		directionNav: false,
		slideshow: true,
		pauseOnHover: true,
		slideshowSpeed: 7000,
	});


	$('ul.tabs li').click(function () {
		var tab_id = $(this).attr('data-tab'), $ct = $(this).closest('.tab-ct');

		$ct.find('ul.tabs li.current').removeClass('current');
		$ct.find('.tab-content.current').removeClass('current');

		$(this).addClass('current');
		$("#" + tab_id).addClass('current');

		$(window).trigger('resize');
	});

	if (!Modernizr.svg) {
		$(".logo a img").attr("src", "assets/img/logo.png");
	}

	$('.popup-youtube, .popup-vimeo, .popup-gmaps').magnificPopup({
		disableOn: 700,
		type: 'iframe',
		mainClass: 'mfp-fade',
		removalDelay: 160,
		preloader: false,
		fixedContentPos: false
	});

	$('.col-product__filter .filters__form :input').on('change', function () {

		$(this).closest('.filters__form').submit();
	});

	// product page download
	$('#product-select-download').on('change', function () {
		if (isNaN(this.value)) {
			window.open(this.value, '_blank');
		} else {
			$('.custom-select__downloads').addClass('download-ajaxing');
			download_product_pdf(this.value);
		}
	});

	$('.product-page-download').on('click', function () {
		var pageID = $(this).data('page-id');

		$(this).addClass('ajaxing');
		download_product_pdf(pageID);
	});

	function download_product_pdf(pageID) {

		const productName = document.getElementById('product-title').innerText;

		const data = {
			action: 'product_download_ajax',
			page_id: pageID,
			product_name: productName
		}

		// download product pdf
		$.ajax({
			url: ajaxurl,
			type: 'POST',
			data: data,
			xhrFields: {
				responseType: 'blob'
			},
			success: function (data) {
				const link = document.createElement('a');
				const fileURL = window.URL.createObjectURL(data);
				link.href = fileURL;
				link.download = productName + '.pdf';
				document.body.append(link);
				link.click();
				link.remove();
				window.URL.revokeObjectURL(fileURL);
				$('.download-ajaxing').removeClass('download-ajaxing');
				$('.ajaxing').removeClass('ajaxing');
			},
			error: function (errorThrown) {
				console.log(errorThrown);
			},
		});
	}
});

jQuery(document).ready(function ($) {

	$('.market-link').on('click', function (e) {
		$('.market-block').toggleClass("hide show--inline"); //you can list several class names
		e.preventDefault();
	});

	////NAVIGATION////

	// if you change this breakpoint in the style.css file (or _layout.scss if you use SASS),
	// don't forget to update this value as well
	var MqL = 1405;
	//move nav element position according to window width
	moveNavigation();
	$(window).on('resize', function () {
		(!window.requestAnimationFrame) ? setTimeout(moveNavigation, 300) : window.requestAnimationFrame(moveNavigation);
		//closeNav();
	});

	// On page load ensure nav is closed
	closeNav();

	//mobile - open lateral menu clicking on the menu icon
	$('.cd-nav-trigger').on('click', function (event) {
		event.preventDefault();
		if ($('.main-content').hasClass('nav-is-visible')) {
			closeNav();
		} else {
			$(this).addClass('nav-is-visible');
			$('.nav__list').addClass('nav-is-visible');
			$('.header').addClass('nav-is-visible');
			$('.main-content').addClass('nav-is-visible').one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function () {
				$('body').addClass('overflow-hidden');
			});
			toggleSearch('close');
		}
	});

	//prevent default clicking on direct children of .nav__list
	$('.nav__list').children('.has-children').children('a').on('click', function (event) {
		event.preventDefault();
	});

	//open submenu
	$('.has-children').children('a').on('click', function (event) {
		if (!checkWindowWidth()) event.preventDefault();
		var selected = $(this);
		if (selected.next('ul').hasClass('is-hidden')) {
			//desktop version only
			selected.addClass('selected').next('ul').removeClass('is-hidden').end().parent('.has-children').parent('ul').addClass('moves-out');
			selected.parent('.has-children').siblings('.has-children').children('ul').addClass('is-hidden').end().children('a').removeClass('selected');
		} else {
			selected.removeClass('selected').next('ul').addClass('is-hidden').end().parent('.has-children').parent('ul').removeClass('moves-out');
		}
		toggleSearch('close');
	});

	//submenu items - go back link
	$('.go-back').on('click', function () {
		$(this).parent('ul').addClass('is-hidden').parent('.has-children').parent('ul').removeClass('moves-out');
	});

	function closeNav() {
		$('.cd-nav-trigger').removeClass('nav-is-visible');
		$('.header').removeClass('nav-is-visible');
		$('.nav__list').removeClass('nav-is-visible');
		$('.has-children ul').addClass('is-hidden');
		$('.has-children a').removeClass('selected');
		$('.moves-out').removeClass('moves-out');
		$('.main-content').removeClass('nav-is-visible').one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function () {
			$('body').removeClass('overflow-hidden');
		});
	}

	function toggleSearch(type) {
		if (type == "close") {
			//close serach
			$('.search').removeClass('is-visible');
		} else {
			//toggle search visibility
			$('.search').toggleClass('is-visible');
			setTimeout(function () { $('#search input[name="q"]').focus() }, 300);
		}
	}

	// Header Search timer
	var xhr = null;
	var typingTimer;
	var doneTypingInterval = 500;
	var $input = $('#search input[name="q"]');

	$input.on('keyup', function () {
		clearTimeout(typingTimer);
		typingTimer = setTimeout(doneTyping, doneTypingInterval);
	});

	$input.on('keydown', function () {
		clearTimeout(typingTimer);
	});

	function doneTyping() {
		doSearch($('#search'), $('#search input[name="q"]').val())
	}

	function doSearch(form, query) {
		if ($.type(query) !== 'string') {
			$('.search__show-hide').addClass('hide');
			return false;
		} else if (!query) {
			$('.search__show-hide').addClass('hide');
			return false;
		}

		if (xhr != null) {
			xhr.abort();
			xhr = null;
		}

		xhr = $.ajax({
			method: "GET",
			url: form.attr("action"),
			data: form.serialize(),
			dataType: 'json'
		})
			.done(function (json) {
				xhr = null;
				hideButton = false;

				if (!(json.products && json.news)) {
					hideButton = true;
				}

				if (!json.products) {
					json.products = '<li><p>Sorry, there are no results to display</p></li>';
				}
				if (!json.news) {
					json.news = '<li><p>Sorry, there are no results to display</p></li>';
				}

				$('.product-search--products').html(json.products);
				$('.product-search--other').html(json.news);
				$('.search__show-hide').removeClass('hide');
				if (hideButton) {
					$('.search__show-hide__btn').addClass('hide');
				} else {
					$('.search__show-hide__btn a').attr('href', $('.search__show-hide__btn a').data('url') + '?q=' + query);
				}
			});
	}

	function toggleFilters(type) {
		if (type == "close") {
			//close serach
			$('.filters').removeClass('is-visible');
		} else {
			//toggle search visibility
			$('.filters').toggleClass('is-visible');
		}
	}

	function toggleDd(type) {
		if (type == "products") {
			$('.dropdown-menu--markets').removeClass('is-visible');
			$('.dropdown-menu--products').toggleClass('is-visible');
		} else {
			$('.dropdown-menu--products').removeClass('is-visible');
			$('.dropdown-menu--markets').toggleClass('is-visible');
		}

		if ($('.dropdown-menu--products').hasClass('is-visible')) {
			$('.drop-link--products').addClass('selected');
		} else {
			$('.drop-link--products').removeClass('selected');
		}

		if ($('.dropdown-menu--markets').hasClass('is-visible')) {
			$('.drop-link--markets').addClass('selected');
		} else {
			$('.drop-link--markets').removeClass('selected');
		}
	}

	$(document.body).on('click', '.alive', function (e) {
		e.preventDefault();
		if ($(this).hasClass('drop-link--products')) {
			toggleDd('products');
		} else {
			toggleDd('markets');
		}
		closeNav();
		//         $("#regions").hide();
		//         $("#product-selectors").hide();

		if ($('.dropdown-menu').hasClass('is-visible')) {
			$('.drop-link').addClass('selected');
		} else {
			$(this).removeClass('selected');
		}
	});

	//open search form
	$('.cd-search-trigger').on('click', function (event) {
		toggleSearch();
		console.log('6');

		$('.dropdown-menu').removeClass('is-visible');
		//         $("#regions").hide();
		//         $("#product-selectors").hide();
		$('.search__bar').find('input[type="search"]').focus();
	});

	// $('#search_toggle').click(function() {
	//     $('.search-aside').toggleClass('search-aside--active');
	// });

	//     $("#search").on("submit", function(e){
	//         e.preventDefault();

	//         doSearch($(this), $(this).find('input[name="q"]').val());

	//         return false;
	//     });

	function checkWindowWidth() {
		//check window width (scrollbar included)
		var e = window,
			a = 'inner';
		if (!('innerWidth' in window)) {
			a = 'client';
			e = document.documentElement || document.body;
		}
		if (e[a + 'Width'] >= MqL) {
			return true;
		} else {
			return false;
		}
	}

	function moveNavigation() {
		var navigation = $('.nav');
		var desktop = checkWindowWidth();
		if (desktop) {
			navigation.detach();
			navigation.insertBefore('.navigation');
		} else {
			navigation.detach();
			navigation.insertAfter('.main-content');
		}
	}

	// Dropdown moves outside container when screensize is bigger than 1405px
	// Moves back into the parent ul within nav if smaller for mobile nav
	function checkWidth() {
		var windowSize = $(window).width();
		var secondary = $('.cd-secondary-nav');

		if (windowSize > 1405) {
			secondary.each(function () {
				$(this).detach();
				if ($(this).hasClass('products-nav')) {
					$(this).appendTo('.dropdown-menu--products .container');
					$('.dropdown-menu--products').removeClass('is-visible');
				} else if ($(this).hasClass('markets-nav')) {
					$(this).appendTo('.dropdown-menu--markets .container');
					$('.dropdown-menu--markets').removeClass('is-visible');
				} else {
					console.log('else');
					$(this).appendTo('.dropdown-menu .container');
					$('.dropdown-menu').removeClass('is-visible');
				}
			});
			$('.drop-link').addClass('alive');
		} else {
			secondary.each(function () {
				$(this).detach();
				$(this).insertAfter('.drop-link');
				$('.drop-link').removeClass('alive');
			});
		}
	}

	// Execute on load
	checkWidth();
	// Bind event listener

	var resizeTimer;

	$(window).on('resize', function (e) {

		clearTimeout(resizeTimer);
		resizeTimer = setTimeout(function () {
			var windowSize = $(window).width();
			var secondary = $('.cd-secondary-nav');
			checkWidth();
		}, 250);

	});

	$(function () {
		var $filterSelect = $('#filter'),
			$sortSelect = $('#SortSelect'),
			$container = $('.members');

		$container.mixItUp();

		$filterSelect.on('change', function () {
			$container.mixItUp('filter', this.value);
		});

		$sortSelect.on('change', function () {
			$container.mixItUp('sort', this.value);
		});
	});

	//call paginate

	$('.result-group ul').paginathing({
		perPage: 5,
		limitPagination: false,
		firstLast: false,
		prevText: '<i class="icon  icon-arrow-left"></i>',
		nextText: '<i class="icon  icon-arrow-left-news"></i>',
		insertAfter: '.result-group'
	});

	$('.result-group-news ul').paginathing({
		perPage: 5,
		limitPagination: false,
		firstLast: false,
		prevText: '<i class="icon  icon-arrow-left"></i>',
		nextText: '<i class="icon  icon-arrow-left-news"></i>',
		insertAfter: '.result-group-news'
	});

	$('.embed-video').click(function () { this.paused ? this.play() : this.pause(); });

});


// Footer
function footerParallax() {
	var header_height = $('header').outerHeight();
	var footer_height = $('footer').outerHeight();
	if ($(window).height() > (header_height + footer_height)) {
		$('.footer-spacer').css('margin-bottom', footer_height);
		$('.footer').addClass('footer--parallax');
	} else {
		$('.footer-spacer').css('margin-bottom', 0);
		$('.footer').removeClass('footer--parallax');
	}
}

$(document).ready(function () {
	footerParallax();
});

$(window).on('resize', function () {
	footerParallax();
});

// we no longer want to show generic region selector on load.
/* $(window).on('load', function () {
	var is_region = getCookie("region");
	if (is_region === "") {
		$('#regions').addClass('active');
	}
}); */
